import Share from "../../../assets/icon/NewsIcons/Share";
import ShareBale from "../../../assets/icon/NewsIcons/ShareBale";
import NewsCalendarBlueSs from "../../../assets/icon/NewsIcons/NewsCalendarBlueSs";
import NewsClockBlueSs from "../../../assets/icon/NewsIcons/NewsClockBlueSs";
import NewsPaper from "../../../assets/icon/NewsIcons/NewsPaper";
import parse from 'html-react-parser';
import moment from 'jalali-moment'

const NewsBox = (props) => {

    return (
        <div className="px-[70px] pt-5 lg:px-[30px] lg:md:px-[10px] md:pt-0">
            <div className="shadow-newsBoxShadow rounded-2xl bg-white mt-6 p-7 md:p-3">
                <div className="flex justify-between align-middle">
                    {/* <div className="w-full flex justify-start items-center">
                        <div
                            className="w-[38px] h-[11px] bg-nextColor rounded-[50px] shadow-yellowShadow mt-[10px]"></div>
                        <div
                            className="w-[11px] h-[11px] mr-[5px] bg-nextColor rounded-[50px] shadow-yellowShadow mt-[10px]"></div>
                        <p className="text-2xl text-mainColor2 font-IRANYekanExtra mx-[15px] md:text-[15px]">{props.title}</p>
                    </div> */}
                    <div className="flex items-center  pt-2 md:flex-wrap">
                        <div className="flex items-center pl-4 border-l-2 border-l-[#D9D9D9] md:mt-2">
                            <NewsCalendarBlueSs fill="#184548" height="16px" width="15px" />
                            <span className="mr-2 text-mainColor2 font-IRANYekanBold text-sm">
                                {
                                    props?.date ?
                                        moment(props?.date?.split("T")[0].replace("-", "/"), 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')

                                        :
                                        "تاریخ"
                                }

                            </span>
                        </div>
                        <div className="flex items-center pl-4 pr-4   md:mt-2">
                            <NewsClockBlueSs fill="#184548" height="16px" width="15px" />
                            <span className="mr-2 text-mainColor2 font-IRANYekanBold text-sm">
                                {props?.date?.split("T")[1].substring(0, 5)}

                            </span>
                        </div>
                    </div>
                    <div className="relative">
                    <button onClick={() => { navigator.clipboard.writeText(props.link);alert("کپی شد!") }
                    }
                        className="rounded-full bg-nextColor shadow-yellowShadow w-[45px] h-[45px] flex justify-center items-center ">

                        <Share />
                    </button>
                    {/* <button className="rounded-full bg-mainColor2 w-[35px] h-[35px] shadow-share-shadow flex justify-center items-center absolute top-[-39px] left-[-7px] ">
                        <ShareBale />

                    </button>
                    <button className="rounded-full bg-mainColor2 w-[35px] h-[35px] shadow-share-shadow flex justify-center items-center absolute top-[-30px] left-[32px] ">
                        <ShareBale />

                    </button>
                    <button className="rounded-full bg-mainColor2 w-[35px] h-[35px] shadow-share-shadow flex justify-center items-center absolute top-[5px] left-[50px] ">
                        <ShareBale />

                    </button>
                    <button className="rounded-full bg-mainColor2 w-[35px] h-[35px] shadow-share-shadow flex justify-center items-center absolute top-[40px] left-[32px] ">
                        <ShareBale />

                    </button>
                    <button className="rounded-full bg-mainColor2 w-[35px] h-[35px] shadow-share-shadow flex justify-center items-center absolute top-[48px] left-[-7px] ">
                        <ShareBale />

                    </button> */}
                    </div>
                </div>
                <div className="flex items-center pr-[66px] pt-2 md:flex-wrap">
                    {/* <div className="flex items-center pl-4 border-l-2 border-l-[#D9D9D9] md:mt-2">
                        <NewsCalendarBlueSs fill="#184548" height="16px" width="15px"/>
                        <span className="mr-2 text-mainColor2 font-IRANYekanBold text-sm">
                            {
                                props?.date?
                                moment(props?.date?.split("T")[0].replace("-","/"), 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')

                                :
                                "تاریخ"
                            }

                        </span>
                    </div>
                    <div className="flex items-center pl-4 pr-4   md:mt-2">
                        <NewsClockBlueSs fill="#184548" height="16px" width="15px"/>
                        <span className="mr-2 text-mainColor2 font-IRANYekanBold text-sm">
                        {props?.date?.split("T")[1].substring(0,5)}

                        </span>
                    </div> */}
                    {/* <div className="flex items-center pl-4 pr-4 md:mt-2 md:pr-0">
                        <NewsPaper fill="#184548" height="16px" width="15px"/>
                        <span className="mr-2 text-mainColor2 font-IRANYekanBold text-sm">
                            کد خبر : 2586
                        </span>
                    </div> */}
                </div>
                <div>
                    <p className="font-IRANYekanMedium text-base mt-4 text-justify leading-8 xs:text-[13px] xs:leading-6">
                        {props.text ?
                            parse(props?.text)
                            : "متن خبر"}
                    </p>
                </div>
                {/* <div className="my-6">
                    <img src={Coins} className="w-full h-[370px] object-cover block mx-auto"/>
                </div> */}
                {/* <div>
                    <p className="font-IRANYekanMedium text-base mt-4 text-justify leading-8">
                        ببه عقیده معامله‌گران فنی در تمام پله‌های کانال 14 میلیون یک مرز مقاومتی وجود دارد که می‌تواند سد افزایش شود. اولین سد افزایش پیش روی بازار طلا 14 میلیون و 630 هزار تومان است که اگر آن را بشکند مرز مقاومتی بعدی در 14 میلیون و 710 هزار تومان خواهد بود. در مقابل مرز حمایتی مهم بازار در 14 میلیون و 410 هزار تومان قرار دارد. براساس پیگیری خبرنگار اقتصادنیوز، گروهی از معامله‌گران معتقدند با کم شدن وضعیت بلوکه در بازار، جان افزایش در بازار سکه دوباره قوت می‌گیرد و قیمت سکه به سمت مرز مقاومتی حرکت خواهد کرد. اما معامله‌گران کاهشی تصور می‌کنند تا مراسم تحلیف بازارساز اجازه نوسان به بازار نخواهد داد.
                    </p>
                </div> */}
            </div>
            <div className="mt-3 flex justify-start items-center flex-wrap">
                <p className="text-[18px] font-IRANYekanBold text-mainColor2 ml-4">برچسب ها :</p>
                {
                    props?.tags?.map((item) => {
                        return (

                            <a href={"/tag/" + item.tag.tagSlug} className="shadow-newsBoxShadow rounded-[15px] bg-backGray w-fit h-[37px] py-1 px-2 ml-3">
                                <p className="font-IRANYekanMedium text-base text-mainColor2 xs:text-[13px]">{item.tag.tag}</p>
                            </a>
                        )
                    })
                }

            </div>
        </div>
    )
}

export default NewsBox;